import { ChangeDetectionStrategy, Component, InputSignal, input } from '@angular/core';

import { TiimeIconModule, TiimeTooltipModule } from 'tiime-material';

@Component({
  selector: 'app-mission-acceptance-form-status-icon',
  standalone: true,
  imports: [TiimeIconModule, TiimeTooltipModule],
  templateUrl: './mission-acceptance-form-status-icon.component.html',
  styleUrl: './mission-acceptance-form-status-icon.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MissionAcceptanceFormStatusIconComponent {
  readonly invalid: InputSignal<boolean> = input<boolean>(false);
}
